export default "__VITE_ASSET__QsgLe2BQ__"